export default __webpack_public_path__ + "static/media/TemplateInflacionBudgetForecast.d1836928.xlsx";